//import * as React from 'react'
import clienteAxios from "./axios";

export const jsonDeserialize = (objJSON) => {
    return JSON.parse(objJSON);
}

export const getCategoriasR = () => {
    return new Promise((resolve, reject) => {
        
        try {
            //Hacemos la peticion a la api
            const respuesta = clienteAxios.get("/getCategorias.aspx");
            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Mantenimiento");
        }
    });
}

export const getArticulosR = ( categoria ) => {
    return new Promise((resolve, reject) => {
        
        try {
            //Hacemos la peticion a la api
            const respuesta = clienteAxios.get("/getArticulos.aspx?idCategoria=" + categoria);
            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Mantenimiento");
        }
    });
}

export const getDetalleArticuloR = ( articulo ) => {
    return new Promise((resolve, reject) => {
        
        try {
            //Hacemos la peticion a la api
            const respuesta = clienteAxios.get("/getDetalleArticulo.aspx?idArticulo=" + articulo);
            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Mantenimiento");
        }
    });
}

export const convertToPrice = ( priceToConvert ) => {
    // Create our number formatter.
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    let dataPrice = formatter.format(priceToConvert);

    return dataPrice;
}

export const encodeNumber = (idNumber) => {
    var hexString = parseInt(idNumber).toString(16);
    return hexString;
}
export const decodeToNumber = (hexString) => {
    var idNumber = parseInt(hexString, 16);
    return idNumber.toString();
}
export const deleteConsecuentsImages = (nameImage) => {
    return nameImage.replace("_1","")
                    .replace("_2","")
                    .replace("_3","")
                    .replace("_4","")
                    .replace("_5","")
                    .replace("_6","")
                    .replace("_7","")
                    .replace("_8","")
                    .replace("_9","");
}